import React from 'react';
import styles from '../styles/Footer.module.scss';

export default function Footer() {
	return (
		<footer className={styles.footer}>
			© Marvel 2021 - All rights reserved
		</footer>
	);
}
